import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Introduction() {
  return (
    <section className="intro_section p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={5}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto text-center order-md-1 order-2"
          >
            <StaticImage
              src="../../../images/case-studies/iremembered/intro_img.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={659}
              height={394}
            />
          </Col>
          <Col
            xs={12}
            md={7}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto  offset-lg-1 order-md-2 order-1"
          >
            <h2 style={{ color: "#000" }}>
              The <span style={{ color: "#FF6C7F" }}>Introduction</span>
            </h2>
            <p>
              iRemembered is a super-simple and reliable text scheduling app
              that ensures you never miss out on another important event,
              occasion, festival or just a message update. It is designed to
              facilitate the users and keep up with the fast-paced world.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Introduction;
